import {clientDetailsStore} from '@store/clients/details/client-details.store';
import {
  getClientDetailsDataSource,
  putClientFacturationModeDataSource
} from '@store/clients/details/client-details.requests';
import {GlobalStatus} from '@store/common/globalStatus.enum';

export class ClientDetailsQuery {
  store = clientDetailsStore;

  clientDetails$ = getClientDetailsDataSource.data$();

  putClientFacturationMode$ = putClientFacturationModeDataSource.data$();

  get isArchived() {
    return this.store.getValue().status === GlobalStatus.ARCHIVED;
  }

  get clientRCNumber() {
    return this.store.getValue().rcNumber;
  }

  get clientDomain() {
    return this.store.getValue().domains;
  }

  get clientCurrency() {
    return this.store.getValue().currency;
  }

  get clientName() {
    return this.store.getValue().name;
  }
}

export const clientDetailsQuery = new ClientDetailsQuery();
